<template>
  <div
    class="the-stats-main"
    v-loading="isStatsLoading"
  >
    <h3>Общая статистика сервиса</h3>
    <div class="the-stats-main__stats">
      <k-stat-card title="Користувачів" icon="el-icon-user" :value="stats.users"/>
      <k-stat-card title="Фондів" icon="el-icon-sugar" :value="stats.foundations"/>
      <k-stat-card title="Акцій" icon="el-icon-location-outline" :value="stats.actions"/>
      <k-stat-card title="Подписок" icon="el-icon-circle-check" :value="stats.emails"/>
      <k-stat-card title="Зібрано" icon="el-icon-coin" :value="`${stats.totalFunds.summ} грн.`"/>
      <k-stat-card title="Благодійників" icon="el-icon-user" :value="stats.totalFunds.countOfPeople"/>
      <k-stat-card title="Стартів" icon="el-icon-medal" :value="stats.starts"/>
      <k-stat-card title="Організаторів" icon="el-icon-trophy" :value="stats.startsOrganizers"/>
      <!-- <k-stat-card title="Пробежали" icon="el-icon-guide" value="0 км"/> -->
    </div>
  </div>
</template>

<script>
/**
 * Component: the-stats-main - Компонент настройки поддерживаемых приложениям языков
 *
 * @version 1.0.0
 */

import { mapGetters, mapActions } from 'vuex';

// Components
import KStatCard from '@/components/KStatCard';


export default {
  name: 'the-stats-main',

  data() {
    return {

    };
  },

  computed: {
    ...mapGetters({
      stats: 'stats/stats',
      isStatsLoading: 'stats/isStatsLoading',
    }),
  },

  async created() {
    await this.getStats();
  },

  methods: {
    ...mapActions({
      getStats: 'stats/getStats',
    }),
  },

  components: {
    KStatCard,
  },
};
</script>

<style lang="scss">
@import '~@/scss/styles';

.the-stats-main {
  $this: &;

  &__stats {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
</style>
